import { AuthContext } from "@context/AuthContext";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function LogoutScreen() {
  const { logout } = useContext(AuthContext);

  const navigate = useNavigate();

  useEffect(() => {
    logout();
    return navigate("/auth/login");
  }, []);

  return <></>;
}
